import { AgeChartDtoToAgeChartChart, AgeTableDtoToAgeTable, AverageKmTableDtoAverageKmalTable, KmChartDtoToKmChartChart, KmTableDtoToKmTable, TotalChartDtoToTotalChartChart, TotalTableDtoToTotalTable, } from '../../../../mappers/Reports/ageKmTotal';
import { translateRegion } from '../../../../utils/formaters';
import { getCurrentGroupId } from '../../../../utils/functions';
import { api } from '../../api';
export const FleetApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getTotalTableData: builder.query({
            query: (params) => ({
                method: 'get',
                url: `api/Frota/Regiao/${getCurrentGroupId()}`,
                params: {
                    regiao: translateRegion(params.region || null),
                    quantidade: params.quantity || 5,
                    busca: params.term || null,
                    pagina: params.page || 1,
                    colunaOrdenacao: params.sorting?.column,
                    direcaoOrdenacao: params.sorting?.direction,
                },
            }),
            transformResponse: (response) => TotalTableDtoToTotalTable(response),
        }),
        getTotalChartData: builder.query({
            query: (params) => ({
                method: 'get',
                url: `api/Frota/Regiao/Indicadores/${getCurrentGroupId()}`,
                params: {
                    regiao: translateRegion(params.region || null),
                    dataInicio: params.startDate,
                    dataFim: params.endDate,
                },
            }),
            transformResponse: (response) => TotalChartDtoToTotalChartChart(response),
        }),
        getAgeTableData: builder.query({
            query: (params) => ({
                method: 'get',
                url: `api/Frota/Idade/${getCurrentGroupId()}`,
                params: {
                    regiao: translateRegion(params.region || null),
                    busca: params.term || null,
                    quantidade: params.quantity || 5,
                    pagina: params.page || 1,
                    colunaOrdenacao: params.sorting?.column,
                    direcaoOrdenacao: params.sorting?.direction,
                },
            }),
            transformResponse: (response) => AgeTableDtoToAgeTable(response),
        }),
        getAgeChartData: builder.query({
            query: (params) => ({
                method: 'get',
                url: `api/Frota/Idade/Indicadores/${getCurrentGroupId()}`,
                params: {
                    regiao: translateRegion(params.region || null),
                    dataInicio: params.startDate,
                    dataFim: params.endDate,
                },
            }),
            transformResponse: (response) => AgeChartDtoToAgeChartChart(response),
        }),
        getKmTableData: builder.query({
            query: (params) => ({
                method: 'get',
                url: `api/Frota/Km/${getCurrentGroupId()}`,
                params: {
                    regiao: translateRegion(params.region || null),
                    busca: params.term || null,
                    quantidade: params.quantity || 5,
                    pagina: params.page || 1,
                    colunaOrdenacao: params.sorting?.column,
                    direcaoOrdenacao: params.sorting?.direction,
                },
            }),
            transformResponse: (response) => KmTableDtoToKmTable(response),
        }),
        getKmChartData: builder.query({
            query: (params) => ({
                method: 'get',
                url: `api/Frota/Km/Indicadores/${getCurrentGroupId()}?`,
                params: {
                    Regiao: translateRegion(params.region || null),
                    DataInicio: params.startDate,
                    DataFim: params.endDate,
                },
            }),
            transformResponse: (response) => KmChartDtoToKmChartChart(response),
        }),
        getAverageKmTableData: builder.query({
            query: (params) => ({
                method: 'get',
                url: `api/Frota/KmMedio/${getCurrentGroupId()}`,
                params: {
                    regiao: translateRegion(params.region || null),
                    busca: params.term || null,
                    quantidade: params.quantity || 5,
                    pagina: params.page || 1,
                    colunaOrdenacao: params.sorting?.column,
                    direcaoOrdenacao: params.sorting?.direction,
                },
            }),
            transformResponse: (response) => AverageKmTableDtoAverageKmalTable(response),
        }),
    }),
});
export const { useGetAgeChartDataQuery, useGetAgeTableDataQuery, useGetAverageKmTableDataQuery, useGetKmChartDataQuery, useGetKmTableDataQuery, useGetTotalChartDataQuery, useGetTotalTableDataQuery, useLazyGetAgeChartDataQuery, useLazyGetAgeTableDataQuery, useLazyGetAverageKmTableDataQuery, useLazyGetKmChartDataQuery, useLazyGetKmTableDataQuery, useLazyGetTotalChartDataQuery, useLazyGetTotalTableDataQuery, } = FleetApi;
